const appComponents = process.env.ACTIVE_THEME ? require('../../themes/' + process.env.ACTIVE_THEME + '/modules/appComponents').appComponents : require('./appComponents').appComponents;

module.exports = function (Vue){
    Object.keys(appComponents).forEach(componentName => Vue.component(componentName, appComponents[componentName]));
}